import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nProvider } from "@/components/context/i18nContext.jsx";
import BrandSignupApp from '@/components/BrandSignup/BrandSignupApp';
import "@/styles/main.scss";

const queryClient = new QueryClient();

const container = document.getElementById('brandSignupRoot');
const dataScript = document.getElementById('brandSignupData');

if (container && dataScript) {
  let reactData;

  try {
    reactData = JSON.parse(dataScript.textContent);
  } catch (error) {
    console.error('Failed to parse brand signup data:', error);
    reactData = {
      brandSignup: {},
      stepFlow: {},
      categories: [],
      csrfToken: '',
      paths: {}
    };
  }

  const { brandSignup, stepFlow, categories, csrfToken, paths, featureFlags } = reactData;

  const root = createRoot(container);
  root.render(
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <BrandSignupApp
          brandSignup={brandSignup}
          stepFlow={stepFlow}
          categories={categories}
          csrfToken={csrfToken}
          featureFlags={featureFlags}
          signupPath={paths.signup}
          completeStepPath={paths.completeStep}
          skipStepPath={paths.skipStep}
          skipToDashboardPath={paths.skipToDashboard}
        />
      </I18nProvider>
    </QueryClientProvider>
  );
}